import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const EmptyStateWrapper = styled.div`
  width: 100%;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  animation: ${fadeIn} 0.4s ease-out;
`;

export const EmptyStateCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 420px;
  padding: 48px 36px;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid #e8ede9;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.04),
    0 8px 24px rgba(0, 0, 0, 0.03);
`;

export const EmptyStateIcon = styled.div<{ $variant?: 'warning' | 'info' }>`
  width: 72px;
  height: 72px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  background: ${({ $variant }) =>
    $variant === 'warning'
      ? 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
      : 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)'};

  svg {
    width: 32px;
    height: 32px;
    color: ${({ $variant }) => ($variant === 'warning' ? '#b45309' : '#047857')};
  }
`;

export const EmptyStateTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #1a2e23;
  margin: 0 0 8px 0;
  line-height: 1.3;
`;

export const EmptyStateDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #5b6f67;
  margin: 0 0 28px 0;
  line-height: 1.6;
`;

export const EmptyStateAction = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #1f6a3d 0%, #2d8a52 100%);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(31, 106, 61, 0.25);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(31, 106, 61, 0.35);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
